import type { ApolloError } from '@apollo/client';

import { isGraphQLAuthError } from 'src/modules/error-handling/error-handling';

import {
  type PersonalDetailsAction,
  Actions as PersonalDetailsActions,
} from './actions';

export const updatePersonalDetailsSuccess = (): PersonalDetailsAction => ({
  type: PersonalDetailsActions.PERSONAL_DETAILS_UPDATE_SUCCESS,
  meta: {
    metrics: {
      'profile-update': true,
    },
  },
});

export const updatePersonalDetailsFailure = (
  error: ApolloError,
): PersonalDetailsAction => ({
  type: PersonalDetailsActions.PERSONAL_DETAILS_UPDATE_FAILURE,
  payload: error,
  meta: {
    metrics: {
      error: !isGraphQLAuthError(error),
    },
  },
});

export const updatePersonalDetails = () => ({
  type: PersonalDetailsActions.PERSONAL_DETAILS_UPDATE_START,
});
